import React from 'react';
import { useToast } from '../../contexts/ToastContext';
import { useTheme } from '../../contexts/ThemeContext';

interface NotificationIndicatorProps {
  onClick?: () => void;
}

export const NotificationIndicator: React.FC<NotificationIndicatorProps> = ({ onClick }) => {
  const { unreadCount } = useToast();
  const { darkMode } = useTheme();
  
  if (unreadCount === 0) {
    return (
      <button
        onClick={onClick}
        className={`p-2 rounded-full ${
          darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-200'
        } transition-colors`}
        aria-label="Notifications"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
      </button>
    );
  }
  
  return (
    <button
      onClick={onClick}
      className={`p-2 rounded-full relative ${
        darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-200'
      } transition-colors`}
      aria-label={`${unreadCount} unread notifications`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 rounded-full bg-red-600">
        {unreadCount > 99 ? '99+' : unreadCount}
      </span>
    </button>
  );
};

export default NotificationIndicator;
